<script>
  export let value;
  export let big = false;
  export let lang = undefined;
  export let mode = undefined;

  // eslint-disable-next-line no-undef
  const preloadedImage = new Image();
  preloadedImage.src = `img/partner/${mode !== 'light' ? value.code : `${value.code}-dark`}.svg`;
</script>

<a href={value.link} class='partner'>
  <div class='partner-box' class:partner-box-big={big}>
    <img class='partner-box-logo' src='img/partner/{mode !== 'light' ? `${value.code}-dark` : value.code}.svg' alt='{value.label[lang]} logo'/>
  </div>
</a>

<style>
  .partner {
    flex-grow: 1;

    width: calc((100% - 60px) / 4);

    text-decoration: none;

    color: inherit;
  }

  .partner-box {
    display: flex;
    gap: 15px;

    height: 75px;

    padding: 25px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);

    transition: box-shadow 1s ease-in-out, transform 1s ease-in-out;
  }

  .partner-box:hover {
    box-shadow: 0px 0px 10px 0px var(--grey-4);

    transform: scale(1.025);
  }

  .partner-box-logo {
    width: 100%;
    height: 100%;

    object-fit: contain;
  }

  .partner-box-big {
    height: 150px;

    padding: 50px;
  }

  :global(body.dark) .partner-box {
    background: var(--grey-8);
  }

  :global(body.dark) .partner-box:hover {
    box-shadow: 0px 0px 10px 0px var(--black);
  }

  :global(body.dark) .partner-box-logo {
    filter: brightness(88%);
  }

  @media only screen and (max-width: 1300px) {
    .partner {
      width: calc((100% - 40px) / 3);
    }
  }

  @media only screen and (max-width: 850px) {
    .partner {
      width: calc((100% - 20px) / 2);
    }
  }

  @media only screen and (max-width: 750px) {
    .partner-box-big {
      padding: 25px;
    }
  }

  @media only screen and (max-width: 750px) {
    .partner {
      width: 100%;
    }
  }
</style>
